module.exports = __webpack_public_path__ + "static/media/fam_knol_space_between.eff5f988.jpg";